export default function HomeFourContact(){
    return(
        <>
            <section class="contact-area pt-115 pb-90 pt-md-55 pb-md-30 pt-xs-55 pb-xs-30 home-4">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-lg-6">
						<div class="section-content mb-20 pl-40 pl-lg-0 pl-md-0 pl-xs-0">
							<div class="image-section">
								<img src="assets/img/home-4/bg-contact.png" alt="" />
							</div>
							<div class="contact-section">
								<ul>
									<li>
										<span class="icon">
											<i aria-hidden="true" class="fas fa-map-marker-alt"></i>
										</span>
										<span class="text">151 New Park Ave, Hartford, CT 06106 United States</span>
									</li>
									<li>
										<span class="icon">
											<i aria-hidden="true" class="fas fa-phone-alt"></i>
										</span>
										<span class="text">+0 123 4567 89</span>
									</li>
									<li>
										<span class="icon">
											<i aria-hidden="true" class="far fa-envelope"></i>
										</span>
										<span class="text">support@waretech.com</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-lg-6">
						<div class="section-title mb-60">
							<h2 class="sect-title">Now Let's Discuss your Project <b>Get a quote!</b></h2>
						</div>
						<form class="row contact-form mb-30" action="#">
							<div class="col-lg-6 col-md-6">
								<div class="input-box mb-20">
									<input type="text" placeholder="Full name" />
								</div>
							</div>
							<div class="col-lg-6 col-md-6">
								<div class="input-box mail-input mb-20">
									<input type="text" placeholder="Email address" />
								</div>
							</div>
							<div class="col-lg-12 mb-20">
								<div class="input-box sub-input">
									<input type="text" placeholder="Subject" />
								</div>
							</div>
							<div class="col-12">
								<div class="input-box text-input mb-15">
									<textarea name="message" cols="30" rows="10" placeholder="Message"></textarea>
								</div>
							</div>

							<div class="col-12">
								<button class="form-btn form-btn2">Get Free Consultation</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}